(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index"] && !Shopify.designMode) return;
  try {
    
	
	
	const screensaver = document.querySelector( '.screensaver' );
	
	const header = document.querySelector( 'header' );
	
	const fadeDelay = 5000;
	
	let fadeTimeout;
	
	if ( screensaver ) {
		
		screensaver.addEventListener( 'click', function( event ) {
			
			screensaver.classList.add( 'show' );
			
			header.classList.remove( 'hide' );
			
			clearTimeout( fadeTimeout );
				
			fadeTimeout = setTimeout( function() {
				
				screensaver.classList.add( 'fade' );
				
			}, fadeDelay);
			
		} );
		
		
	}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    

const wrapper = document.querySelector('.page-info-cta');
const cta = document.querySelector('.page-info-cta-link');

if ( wrapper && cta ) {
	
	cta.addEventListener( 'click', (event) => {
		
		event.preventDefault();
		
		wrapper.classList.toggle( 'show' );
		
	});
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    

const wrapper = document.querySelector('.product-info-cta');
const cta = document.querySelector('.product-info-cta-link');

if (wrapper && cta) {
	
  cta.addEventListener( 'click', (event) => {
	  
	  event.preventDefault();
	  
	  wrapper.classList.toggle('show');
	  
  });
}


  } catch(e) { console.error(e); }
})();
})();
